// extracted by mini-css-extract-plugin
export default {"wrapper":"more-actions_wrapper__9jdGQ","item":"more-actions_item__ksB4J"};